import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-12 right-2"
}
const _hoisted_3 = { class: "flex gap-4" }

import {
	UiCheckbox,
	UiDatePicker,
	UiForm,
	UiInput,
	UiButton,
	UiSelect,
	UiFormError,
	UiRadioTabs,
	UiLoader,
	useForm
} from '@/ui-kit';
import { Nullable } from '@/utils';
import { required } from '@vuelidate/validators';
import { computed } from 'vue';
import { format } from 'date-fns';
import { useDoorLoop } from '../use-door-loop';
import { useToggle } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoorLoopVendorBillBlock',
  emits: ["success"],
  setup(__props, { emit }: { emit: ({
	(e: 'success'): void;
}), expose: any, slots: any, attrs: any }) {



const {
	loadProperties,
	loadAccounts,
	loadVendors,
	createVendorBill,
	resetPropertyData,
	state
} = useDoorLoop();
const [isLoading, toggleLoading] = useToggle(true);
const [isLoadingPropertyData, toggleLoadingPropertyData] =
	useToggle();

async function init() {
	await Promise.all([loadProperties(), loadVendors()]);
	toggleLoading(false);
}

init();

const { formData, onSubmit, loading, validator } = useForm(
	{
		amount: '',
		date: new Date(),
		due_date: new Date(),
		reference: '',
		property_id: null as Nullable<string>,
		vendor_id: null as Nullable<string>,
		account_id: null as Nullable<string>
	},
	{
		amount: {
			required,
			moreThan0: {
				$validator: (value) => {
					return (
						typeof value === 'string' &&
						!isNaN(parseFloat(value)) &&
						parseFloat(value) > 0
					);
				},
				$message: 'Amount is invalid'
			}
		},
		property_id: {
			required
		},
		date: {
			required
		},
		due_date: {
			required
		},
		account_id: {
			required
		},
		reference: {
			required
		},
		vendor_id: {
			required
		}
	}
);

async function loadPropertyData(id: string) {
	toggleLoadingPropertyData(true);
	validator.value.$reset();
	validator.value.$clearExternalResults();
	resetPropertyData();
	formData.account_id = null;
	await loadAccounts(id);
	toggleLoadingPropertyData(false);
}

const submit = onSubmit(async (data) => {
	await createVendorBill({
		amount: data.amount,
		reference: data.reference,
		property_id: data.property_id!,
		vendor_id: data.vendor_id!,
		account_id: data.account_id!,
		date: format(data.date, 'yyyy-MM-dd'),
		due_date: format(data.due_date, 'yyyy-MM-dd')
	});
	emit('success');
});

const properties = computed(() =>
	state.value.properties.map((property) => ({
		title: property.name,
		value: property.id
	}))
);

const vendors = computed(() =>
	state.value.vendors.map((vendor) => ({
		title: vendor.fullName,
		value: vendor.id
	}))
);

const accounts = computed(() =>
	state.value.accounts.map((account) => ({
		title: account.name,
		value: account.id
	}))
);

const depositStatuses = computed(() => [
	{
		title: 'Deposited',
		value: 'DEPOSITED'
	},
	{
		title: 'Undeposited',
		value: 'UNDEPOSITED'
	}
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UiForm), {
    class: "pb-2 relative",
    onSubmit: _unref(submit)
  }, {
    default: _withCtx(() => [
      (_unref(isLoading))
        ? (_openBlock(), _createBlock(_unref(UiLoader), {
            key: 0,
            wrapperClass: "text-reverse base-darken",
            loadingText: "Loading data..."
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(UiInput), {
        label: "Amount",
        type: "number",
        disabled: _unref(loading),
        name: "amount",
        step: ".01",
        modelValue: _unref(formData).amount,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).amount) = $event)),
        placeholder: "Enter amount"
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(_unref(UiInput), {
        label: "Invoice No / Reference",
        name: "reference",
        disabled: _unref(loading),
        modelValue: _unref(formData).reference,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).reference) = $event)),
        placeholder: "Enter Check No / Reference"
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(_unref(UiSelect), {
        label: "Vendor",
        name: "vendor_id",
        disabled: _unref(loading),
        modelValue: _unref(formData).vendor_id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).vendor_id) = $event)),
        options: _unref(vendors),
        placeholder: "Select Vendor"
      }, null, 8, ["disabled", "modelValue", "options"]),
      _createVNode(_unref(UiSelect), {
        label: "Propery",
        name: "property_id",
        disabled: _unref(loading),
        modelValue: _unref(formData).property_id,
        "onUpdate:modelValue": [
          _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).property_id) = $event)),
          _cache[4] || (_cache[4] = ($event: any) => (loadPropertyData($event)))
        ],
        options: _unref(properties),
        placeholder: "Select Propery"
      }, null, 8, ["disabled", "modelValue", "options"]),
      _createElementVNode("div", _hoisted_1, [
        (_unref(isLoadingPropertyData))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(UiLoader))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(UiSelect), {
          label: "Account",
          name: "account_id",
          disabled: 
					_unref(loading) ||
					_unref(isLoadingPropertyData) ||
					!_unref(accounts).length
				,
          options: _unref(accounts),
          modelValue: _unref(formData).account_id,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).account_id) = $event)),
          placeholder: "Select account"
        }, null, 8, ["disabled", "options", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(UiDatePicker), {
          label: "Invoice Date",
          name: "date",
          disabled: _unref(loading),
          modelValue: _unref(formData).date,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).date) = $event))
        }, null, 8, ["disabled", "modelValue"]),
        _createVNode(_unref(UiDatePicker), {
          label: "Due Date",
          name: "due_date",
          disabled: _unref(loading),
          modelValue: _unref(formData).due_date,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).due_date) = $event))
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createVNode(_unref(UiButton), {
        type: "submit",
        class: "!h-9",
        theme: "secondary",
        loading: _unref(loading)
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Add Bill ")
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}
}

})